<form id="section" [formGroup]="formGroup">
  <nh-notifications></nh-notifications>

  <nh-top-level
    [topLevelName]="topLevelName"
    [answerControl]="formGroup.get('extras.topLevelAnswer')"
    [mode]="mode"
    [label]="topLevelQuestion"
    [popupText]="popupText"
    [topLevelHint]="topLevelHintText"
    [initialTopLevelAnswer]="initialTopLevelAnswer"
    [topLevelLabelSize]="topLevelLabelSize"
    [topLevelCol9]="topLevelCol9"
  >
    <ng-content top-level-info select="[form-top]"></ng-content>

    @if (individualQuestion) {
    <nh-field [label]="individualQuestion" class="label-section">
      @if (hintText) {
      <div class="hint" [innerHtml]="hintText | globalTranslate"></div>
      }
      <select
        nhTranslate
        id="individuals"
        name="individuals"
        [attr.aria-label]="individualQuestionAria || individualQuestion"
        bindLabel="name.fullName"
        bindId="identifier"
        [items]="individuals"
        [formControl]="formGroup.get('extras.individual')"
        (change)="onIndividualChange($event)"
        required
      ></select>
    </nh-field>
    }

    <ng-content></ng-content>
  </nh-top-level>
</form>